import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { AuthGuard } from '../../shared/guards/auth.guards';
import { Groups } from '../security/model/groups.model';
import { IssueListComponent } from './components/list/issue-list.component';

export class IssueRoutingStates {
  public static readonly LIST = {
    url: 'issue'
  };
}

export const IssueRoutes: Routes = [
  {
    path: IssueRoutingStates.LIST.url,
    data: {
      page: {
        title: 'Issue List'
      },
      requiresRole: [Groups.CLIENT_ADMIN]
    },
    component: IssueListComponent,
    canActivate: [AuthGuard]
  }
];

@NgModule({
  exports: [RouterModule],
  imports: [RouterModule.forChild(IssueRoutes)]
})
export class IssueRoutingModule {}
